import { useSelector } from "react-redux";
import { Banner } from "app/modules/shared/banner/Banner";
import { selectConnectMaintenanceDate } from "./MaintenanceSlice";

export const ConnectMaintenanceNotification: React.FC = () => {
  const maintenanceDate = useSelector(selectConnectMaintenanceDate);

  return (
    maintenanceDate && (
      <Banner
        data-test-id="maintenance-banner__dismiss-button"
        title="Connect maintenance scheduled"
        iconClassName="fa-warning"
        textDark
      >
        {`Connect will be down for scheduled maintenance from ${maintenanceDate.toCPLUserFriendlyTimeString()} on
            ${maintenanceDate.toCPLUserFriendlyDateString()}. We apologise for any inconvenience.`}
      </Banner>
    )
  );
};
